
import React, {Component} from 'react';
import PropTypes from 'prop-types';


export const BtnConfig = [{
    name:'all',
    btnStatus:false,
    btnNames:  ["MyUpload", "NewFolder", "Partake", "DownLoad", "Delete", "Rename", "Move", "SetLabel", "IsOpen"]
},
    {
        name:'all',
        btnStatus:true,
        btnNames: []
    },
    {
        name:'public',
        btnStatus:true,
        btnNames: []
    },
   {  name:'public',
       btnStatus:false,
       btnNames: [[], ["Partake", "DownLoad", "AskFor"]]
   },
    { name:'dept',
      btnStatus:false,
      btnNames:["MyUpload", "NewFolder", "Partake", "DownLoad", "Delete", "Rename", "Move", "SetLabel", "IsOpen"]
    },
    {name:'person',
     btnStatus:false,
     btnNames:["MyUpload", "NewFolder", "Partake", "DownLoad", "Delete", "Rename", "Move", "SetLabel", "IsOpen"]
    }
];
